import { CalendarModule } from 'angular-calendar';
import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseScheduledItemCreateComponent } from '@leads/client-facing/classes/base-scheduled-item-create.component';
import { TimeEditorComponent } from '@leads/client-facing/components/time-editor/time-editor.component';
import { CalendarDayViewComponent } from '@schedule/lib/components/calendar-day-view/calendar-day-view.component';
import { DatePickerDropdownComponent } from '@shared/components/calendar/date-picker-dropdown/date-picker-dropdown.component';
import { DropdownControlComponent } from '@shared/components/forms/dropdown-control/dropdown-control.component';
import { StandardGroupControlComponent } from '@shared/components/forms/standard-group-control/standard-group-control.component';
import { SwitchControlComponent } from '@shared/components/forms/switch-control/switch-control.component';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';
import { HeaderPopoverComponent } from '@shared/components/sections/header-popover/header-popover.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';
import { ModalService } from '@shared/services/modal/modal.service';
import { OffcanvasService } from '@shared/services/offcanvas/offcanvas.service';

@Component({
	selector: 'app-mobile-scheduled-item-create-offcanvas',
	imports: [
		CommonModule,
		ReactiveFormsModule,
		StepNavigatorComponent,
		DatePickerDropdownComponent,
		DropdownControlComponent,
		CalendarModule,
		StandardGroupControlComponent,
		TextareaControlComponent,
		SwitchControlComponent,
		CalendarDayViewComponent,
		HeaderPopoverComponent,
	],
	templateUrl: './mobile-scheduled-item-create-offcanvas.component.html',
	styleUrl: './mobile-scheduled-item-create-offcanvas.component.scss',
	host: {
		class: 'h-100',
		style: 'display: contents',
	},
})
export class MobileScheduledItemCreateOffcanvasComponent extends BaseScheduledItemCreateComponent {
	private offcanvasService = inject(OffcanvasService);
	private modalService = inject(ModalService);

	openEditTime(): void {
		const modalRef = this.modalService.open(TimeEditorComponent, false, 'lg');
		const componentInstance = modalRef.componentInstance as TimeEditorComponent;
		componentInstance.formGroup = this.schedulerForm;
		componentInstance.selectedDate = this.schedulerForm.controls.selectedDate.value!;
		componentInstance.confirmAction.pipe(take(1)).subscribe(() => {
			this.updateNewAssessmentEvent(this.selectedStartTime.value as Date, this.selectedEndTime.value as Date);
			this.updateTimePickerEvents();
		});
	}

	close(): void {
		this.offcanvasService.dismissLast();
	}
}
